<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
            </div>
            <div :class="fieldValueClass">
                <dx-lookup
                    v-model:value="value"
                    :data-source="dataSource"
                    :value-expr="meta.extParams.valueExpr"
                    :display-expr="meta.extParams.displayExpr"
                    :search-enabled="true"
                    search-mode="contains"
                    :min-search-length="2"
                    :showDataBeforeSearch="true"
                    :disabled="disabled"
                    @valueChanged="valueChanged"
                    @opened="onOpenHandler"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, computed, onBeforeMount, ref } from 'vue';
import { getDictionary } from '@/service/card-service';
import { DxLookup } from 'devextreme-vue';
const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null, getDictionary: null }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.ds);

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    if (props.meta.extParams) {
        const initialDS = [
            {
                [`${props.meta.extParams.valueExpr}`]: userData?.value[props.meta.fieldNameId],
                [`${props.meta.extParams.displayExpr}`]: userData?.value[props.meta.fieldNameText],
            },
        ];
        if (dataSource.value.length === 0 && serverData?.value.length !== 0 && initialDS) {
            dataSource.value = initialDS;
        }
    }
});

const getDictionaryHandler = async () => {
    if (props.callbacks.getDictionary) {
        await props.callbacks.getDictionary();
    } else {
        let args = {};
        props.meta.extParams.argsExpr.forEach((item) => {
            args[item] = (!userData?.value[item]) ? -1 : userData?.value[item];

        });
        const response = await getDictionary(props.meta.extParams.dictionaryRoutePath, args);
        if (response) {
            dataSource.value = response;
        } else {
            console.log(response.error, response.uuid);
        }
    }
};

const valueChanged = e => {
    userDataChange(e.value);
};

const userDataChange = value => {
    userData.value[props.meta.fieldNameId] = value;
    props.callbacks.userDataChanged();
};

const isModified = computed(() => {
    return userData?.value[props.meta.fieldNameId] !== serverData?.value[props.meta.fieldNameId];
});

const value = computed(() => {
    return userData.value[props.meta.fieldNameId] ?? null;
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': isModified.value,
    };
});
</script>
